import { Typography } from '@mui/material';

const SectionInfoDetail = ({ detail }) => {
  return (
    <Typography sx={{ wordBreak: 'break-word', display: 'flex' }}>
      {detail}
    </Typography>
  );
};

export default SectionInfoDetail;
